<template>
  <div class="page-container">
    <UiToastList/>
    <div class="full-height-container h-full sm:h-full md:h-screen">
      <div class="flex flex-wrap">
        <div
          class="w-full sm:w-1/1 md:w-1/2 h-64 sm:h-64 md:h-screen"
        >
          <img
            class="w-full h-64 sm:h-64 md:h-screen object-cover object-center"
            src="@/assets/img/demo3.png"
            alt="Toyota"
          />
        </div>
        <!-- ... -->
        <div
          class="w-full sm:w-1/1 md:w-1/2 authorize-container h-auto sm:h-auto md:h-screen"
        >
          <div
            class="flex flex-col justify-center sm:min-auto min-h-full"
          >
            <h1 class="mb-8">
              <router-link :to="{ name: 'index'}" class="main-logo">
                <img src="@/assets/img/logo.png" alt="Toyota" />
              </router-link>
            </h1>
            <p class="text-left mb-4 page-title">
              Cập nhật mật khẩu mới
            </p>
            <p class="mb-8 page-noted">
              * Mật khẩu bao gồm: Chữ hoa và thường, số, ký tự
              đặc biệt, tối thiểu 12 ký tự.
            </p>
            <div
              class="w-full sm:w-full md:w-auto form-container"
            >
                <div class="mb-4 form-controls">
                  <label
                    class="block text-sm font-bold mb-2"
                  >
                    Nhập mật khẩu mới
                  </label>
                  <div class="relative">
                    <input
                      class="appearance-none border w-full py-4 px-4 mb-2 text-gray-700 leading-tight focus:outline-none pr-10"
                      :type="passwordInputType"
                      placeholder="Mật khẩu"
                      v-model="newPassword"
                    />
                    <!-- Xử lý bật tắt hiển thị password tương ứng icon-eye hoặc icon-eye-off -->
                    <i
                      :class="[ passwordInputType === 'password' ? 'icon-eye-off' : 'icon-eye' ]"
                      class="vlicon"
                      @click="showPassword"
                    ></i>
                  </div>
                  <p
                    :class="[ submitted && $v.newPassword.$error && !$v.newPassword.required ? 'block' : 'hidden' ]"
                    class="text-red-400 text-error mb-4"
                  >
                    Vui lòng nhập mật khẩu mới
                  </p>
                  <p
                    :class="[ submitted && $v.newPassword.$error && !$v.newPassword.complex ? 'block' : 'hidden' ]"
                    class="text-red-400 text-error mb-4"
                  >
                    Mật khẩu không đúng định dạng
                  </p>
                </div>
                <div class="mb-4 form-controls">
                  <label
                    class="block text-sm font-bold mb-2"
                  >
                    Xác nhận mật khẩu mới
                  </label>
                  <div class="relative">
                    <input
                      class="appearance-none border w-full py-4 px-4 mb-2 text-gray-700 leading-tight focus:outline-none pr-10"
                      :type="passwordInputType"
                      placeholder="Mật khẩu"
                      v-model="confirmPassword"
                    />
                    <!-- Xử lý bật tắt hiển thị password tương ứng icon-eye hoặc icon-eye-off -->
                    <i
                      :class="[ passwordInputType === 'password' ? 'icon-eye-off' : 'icon-eye' ]"
                      class="vlicon"
                      @click="showPassword"
                    ></i>
                  </div>
                  <p
                    :class="[ submitted && $v.confirmPassword.$error && !$v.confirmPassword.required ? 'block' : 'hidden' ]"
                    class="text-red-400 text-error mb-4"
                  >
                    Vui lòng nhập xác nhận mật khẩu
                  </p>
                  <p
                    :class="[ submitted && $v.confirmPassword.$error && !$v.confirmPassword.sameAsPassword ? 'block' : 'hidden' ]"
                    class="text-red-400 text-error mb-4"
                  >
                    Mật khẩu nhập lại không trùng
                  </p>
                </div>
                <div>
                  <button
                    class="submit-button block mt-8 w-full mb-2 bg-red-500 hover:bg-red-400 text-white font-bold py-2 px-4 border-red-700 hover:border-red-500 rounded"
                    @click="updatePassword"
                  >
                    <vue-element-loading :active="isRequest"/>
                    Xác nhận
                  </button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'
import { UsersService } from '@/services/users.service'
import UiToastList from '@/components/UiToastList'
const complex = (value) => {
  // eslint-disable-next-line no-useless-escape
  const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{12,})')
  return strongRegex.test(value)
}
export default {
  name: 'ResetPassword',
  mixins: [validationMixin],
  components: {
    UiToastList
  },
  data () {
    return {
      submitted: false,
      newPassword: '',
      confirmPassword: '',
      passwordInputType: 'password',
      isRequest: false
    }
  },
  validations: {
    newPassword: { required, complex },
    confirmPassword: { required, sameAsPassword: sameAs('newPassword') }
  },
  methods: {
    updatePassword: function () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.isRequest = true
      UsersService.changePassword(this.$route.params.password, this.newPassword).then(response => {
        if (response.data.data.IsResult === false) {
          this.$store.commit('toast/NEW', { type: 'error', message: 'Có lỗi xảy ra' })
          this.isRequest = false
          return
        }
        this.$router.push({ name: 'resetPasswordSuccess' })
      }).catch(error => console.log(error))
    },
    showPassword () {
      if (this.passwordInputType === 'password') {
        this.passwordInputType = 'text'
      } else {
        this.passwordInputType = 'password'
      }
    }
  }
}
</script>
